import "quill/dist/quill.core.css";

interface Props {
  html: string;
  className?: string;
}

const QuillHtmlContent = ({ html, className = "" }: Props) => (
  <div
    className={`ql-editor quill-html-content ${className}`.trim()}
    style={{
      height: "auto",
      minHeight: 0,
      overflowY: "visible",
      padding: 0,
    }}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

export default QuillHtmlContent;
